window.cart =
{
    bindQuickOrderImportForm: function (form)
    {
        var inputFile = form.querySelector("input[type='file']");
        inputFile.addEventListener("change", () =>
        {
            if (inputFile.files.length === 0)
                return;

            form.submit();
        });

        var button = form.querySelector("button");
        button.addEventListener("click", () =>
        {
            inputFile.click();
        });
    },
    CTA: function ()
    {
        var handHeldToolbar = document.querySelector(".handheld-toolbar");
        var button = document.querySelector("*[data-cta-stop]");

        if (!handHeldToolbar || !button)
            return;

        var buttonOffset = document.querySelector("*[data-cta-stop]").offsetTop;
        var toolbarHeight = handHeldToolbar.getBoundingClientRect().height;

        var ctaElement = document.querySelector("*[data-cta]");

        if (!ctaElement)
            return;

        if (window.scrollY + window.outerHeight >= buttonOffset + toolbarHeight)
        {
            ctaElement.classList.add("d-none");
            handHeldToolbar.classList.remove("shadow-none");
        }
        else
        {
            ctaElement.classList.remove("d-none");
            handHeldToolbar.classList.add("shadow-none");
        }
    },
    // Odebrání položky z košíku
    deleteRow: function (cartItemId)
    {
        var element = document.querySelector("*[data-cart-row-id='" + cartItemId + "']");

        if (element === null)
            return;

        element.remove();

        var elements = document.querySelectorAll("*[data-cart-row-id]");

        if (elements.length > 0)
            return;

        window.location.reload();
    },
    showModal: function ()
    {
        var cartModal = document.getElementById("cart-modal");

        var cartModalInstance = new bootstrap.Modal(cartModal);
        cartModalInstance.show();
    },
    init: function ()
    {
        var quickOrderImportForm = document.querySelector("#quick-import-form");

        if (quickOrderImportForm)
            cart.bindQuickOrderImportForm(quickOrderImportForm);

        var cartItemsContainer = document.querySelector('#cart-items-container');

        if (!cartItemsContainer)
            return;

        window.addEventListener("scroll", cart.CTA);

        cart.CTA();
    }
};

//export default cart;